import { AddToCartProps } from '@teko/ecommerce';
import { CartContextState } from '../contexts/CartContext';
import { BannerEntity } from './entities';
import {
  DiscoveryPromotion,
  ProductDetailProductGroupVariant,
  ProductDetailProductGroupVariantAttrValue,
  ProductDetailSeoInfo,
  ProductStatus,
  ProductInfoCategory,
  ProductDetailAttributeGroup,
  ProductDetailAttributeSet,
  ProductProvider,
  Brand,
  DiscoverySellerProvider,
  DiscoveryProduct,
  BenefitItems,
  BenefitVoucher,
} from '@teko/discovery';

export interface SearchProductPagination {
  totalItems: number;

  totalPages: number;
}

export interface ServerProduct {
  products: DiscoveryProduct[];
}

export interface DisplayFilterValue {
  count?: number;
  option: string;
  value: string;
  code?: string;
  name?: string;
}

export interface DisplayFilter {
  code: string;
  name: string;
  values: DisplayFilterValue[];
}

export interface DisplayPagination {
  totalItems?: number;
  page?: number;
  pageSize?: number;
}

export interface ProductResponse {
  product: DiscoveryProduct;
}

export interface ConfigurationOption {
  value: string;
  optionId: number;
  thumbnailUrl: string;
  visible: boolean;
  selected: boolean;
}

export interface ConvertedConfiguration {
  id: number;
  code: string;
  name: string;
  optionType: string;
  options: ConfigurationOption[];
}

export interface ConvertedProduct {
  sku: string;
  sellerSku: string;
  tags?: string[];
  flashSale?: {
    total: number;
    used: number;
    endAt: string;
    type: string;
  };
  status?: ProductStatus;
  images: {
    src: string;
    alt: string;
  }[];
  title: {
    name: string;
    status?: {
      value: string;
      color: string;
    };
  };
  name: string;
  displayName: string;
  price: {
    price?: string | number;
    supplierRetailPrice?: string | number;
    listedPrice?: string | number;
    terminalPrice?: string | number;
    sellPrice?: string | number;
    discount?: string | number;
    priceWithoutSelectionPromotion?: number;
  };
  seoInfo?: ProductDetailSeoInfo;
  brand: Brand;
  categories: ProductInfoCategory[];
  masterCategories: ProductInfoCategory[];
  attributeGroups?: ProductDetailAttributeGroup[];
  attributes?: any[];
  needManageStock: boolean;
  totalAvailable?: number;
  attributeSet?: ProductDetailAttributeSet;
  provider?: ProductProvider;
  seller?: DiscoverySellerProvider;
  selected?: ProductDetailProductGroupVariantAttrValue[];
  orderCouponPromotions?: DiscoveryPromotion[];
  partOrderPromotions?: DiscoveryPromotion[];
  defaultPromotions?: DiscoveryPromotion[];
  selectionPromotions?: DiscoveryPromotion[];
  productGroup?: {
    id: number;
    name: string;
    visible: string;
    variants?: ProductDetailProductGroupVariant[];
    configurations?: ConvertedConfiguration[];
  };
  isBundle?: boolean;
  addToCart?: AddToCartProps;
  save?: number;
  saveWithoutSelectionPromotion?: number;
  selectPromotionId?: number;
  isAlcoholicCategory?: boolean;
  uomName?: string;
  uomRatio?: number;

  clearanceTypeDescription?: string;
}

export interface OptionConvertProductCart {
  frames?: BannerEntity[];
  cart?: CartContextState;
  hasBrand?: boolean;
  showUom?: boolean;
  contactLink?: string;
}

export interface DiscoveryKeyword {
  query: string;
  highlight?: string;
  categoryName?: string;
  categoryCode?: string;
  categoryId?: number;
}

export interface ComboItem {
  type: 'autogen' | 'dynamic';
  supplierRetailPrice: number;
  latestPrice: number;
  promotion?: DiscoveryPromotion;
  promotionId?: number;
  items: {
    quantity: number;
    product: DiscoveryProduct;
  }[];
}

export interface ComboProduct {
  sku: string;
  image: string;
  name: string;
  selectedVariant: string[];
  quantity: number;
  supplierRetailPrice: number;
  latestPrice: number;
  totalAvailable: number | null;
  selectionPromotionId?: number;
  selectionPromotion: DiscoveryPromotion;
  selectionPromotions: DiscoveryPromotion[];
  defaultPromotions: DiscoveryPromotion[];
  allowSelectPromotion?: boolean;
  gifts: BenefitItems[];
  vouchers: BenefitVoucher[];
  saveWithoutSelectionPromotion?: number;
  productConfigurations?: ConvertedConfiguration[];
  priceWithoutSelectionPromotion?: number;
}

export enum PromotionApplyOnEnum {
  product = 'product',
  partOrder = 'part-order',
}
